module.exports = __webpack_public_path__ + "static/media/George W. Bush (I) - 2004.acb31f41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/George W. Bush (I) - 2004.jpg
// module id = 475
// module chunks = 0